import { render, staticRenderFns } from "./regional.vue?vue&type=template&id=13891ee3&scoped=true&"
import script from "./regional.vue?vue&type=script&lang=js&"
export * from "./regional.vue?vue&type=script&lang=js&"
import style0 from "./regional.vue?vue&type=style&index=0&id=13891ee3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13891ee3",
  null
  
)

export default component.exports